import React from 'react';
import { Layers, Scale, Sparkles } from 'lucide-react';

export type RegisterViewMode = 'controls' | 'provisions';

interface ViewToggleProps {
  viewMode: RegisterViewMode;
  onChangeViewMode: (mode: RegisterViewMode) => void;
  controlsCount: number;
  provisionsCount: number;
}

export default function ViewToggle({
  viewMode,
  onChangeViewMode,
  controlsCount,
  provisionsCount,
}: ViewToggleProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-1.5 rounded-2xl bg-slate-200/80 dark:bg-slate-800/80 p-1.5 border border-slate-300/60 dark:border-slate-700/60">
      
      {/* Dual Tab Buttons */}
      <div className="grid grid-cols-2 gap-1.5 flex-1">
        
        {/* Controls View */}
        <button
          onClick={() => onChangeViewMode('controls')}
          className={`flex items-center justify-center gap-2 py-2 px-3 rounded-xl text-xs font-bold transition-all ${
            viewMode === 'controls'
              ? 'bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 shadow-sm border border-slate-200 dark:border-slate-700'
              : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200'
          }`}
        >
          <Layers className={`w-4 h-4 ${viewMode === 'controls' ? 'text-accent' : 'text-slate-400'}`} />
          <span className="truncate">Operational Controls Matrix</span>
          <span className={`px-1.5 py-0.5 rounded text-[10px] font-mono ${
            viewMode === 'controls'
              ? 'bg-accent/10 dark:bg-accent/20 text-accent dark:text-accent-light'
              : 'bg-slate-300/60 dark:bg-slate-700 text-slate-600 dark:text-slate-400'
          }`}>
            {controlsCount} Controls (OBL-01..54)
          </span>
        </button>

        {/* Provisions View */}
        <button
          onClick={() => onChangeViewMode('provisions')}
          className={`flex items-center justify-center gap-2 py-2 px-3 rounded-xl text-xs font-bold transition-all ${
            viewMode === 'provisions'
              ? 'bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 shadow-sm border border-slate-200 dark:border-slate-700'
              : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200'
          }`}
        >
          <Scale className={`w-4 h-4 ${viewMode === 'provisions' ? 'text-accent' : 'text-slate-400'}`} />
          <span className="truncate">Statutory Provisions & Rules</span>
          <span className={`px-1.5 py-0.5 rounded text-[10px] font-mono ${
            viewMode === 'provisions'
              ? 'bg-accent/10 dark:bg-accent/20 text-accent dark:text-accent-light'
              : 'bg-slate-300/60 dark:bg-slate-700 text-slate-600 dark:text-slate-400'
          }`}>
            {provisionsCount} Statutory Rows
          </span>
        </button>

      </div>
    </div>
  );
}
